/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ref_N2Inputs */

const en_sorter_ref_n2 = /** @type {(inputs: Sorter_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same letter, so case decides and lowercase comes first.`)
};

const ko_sorter_ref_n2 = /** @type {(inputs: Sorter_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`같은 글자이므로 대소문자가 결정하고 소문자가 앞섭니다.`)
};

const ja_sorter_ref_n2 = /** @type {(inputs: Sorter_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ文字なので大文字小文字が決め手になり、小文字が前に来ます。`)
};

/**
* | output |
* | --- |
* | "Same letter, so case decides and lowercase comes first." |
*
* @param {Sorter_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ref_n2 = /** @type {((inputs?: Sorter_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ref_n2(inputs)
	if (locale === "ko") return ko_sorter_ref_n2(inputs)
	return ja_sorter_ref_n2(inputs)
});